module.exports = __webpack_public_path__ + "img/unidad-1.da4b0374.png";